import '../admin-user.scss';
import { useNavigate } from 'react-router-dom';
import { Typography } from '../../../components/typography/typography';
import { Card } from '../../../components/card/card';
import { useAdmin } from '../../../hooks/use-admin-context';
import Icon from '../../../components/icons/icon';

export const AdminProfile = () => {
  const { username, email, name } = useAdmin();
  const navigate = useNavigate();

  return (
    <div className="admin-user">
      <div className="container-v2">
        <div className="flex items-center gap-2 mb-5">
          <div className="cursor-pointer" onClick={() => navigate(-1)} data-cy="back-button">
            <Icon icon="Back" size="large" className="text-grey-600" />
          </div>
          <Typography type="display-sm" weight="medium">
            My Profile
          </Typography>
        </div>

        <Card>
          <div className="w-full space-y-4">
            <div className="flex flex-col">
              <Typography type="text-md" weight="medium" className="text-grey-800">
                Full Name
              </Typography>
              <Typography type="text-sm" weight="regular" className="text-quipli-black-500">
                {name}
              </Typography>
            </div>

            <div className="flex flex-col">
              <Typography type="text-md" weight="medium" className="text-grey-800">
                Primary Email
              </Typography>
              <Typography type="text-sm" weight="regular" className="text-quipli-black-500">
                {email}
              </Typography>
            </div>

            <div className="flex flex-col">
              <Typography type="text-md" weight="medium" className="text-grey-800">
                Username
              </Typography>
              <Typography type="text-sm" weight="regular" className="text-quipli-black-500">
                {username}
              </Typography>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
